import React from "react";
import { connect } from "react-redux";
import { isMobileBrowser } from "../../base/environment/utils";
import { translate } from "../../base/i18n/functions";
import Icon from "../../base/icons/components/Icon";
import { IconWarning } from "../../base/icons/svg";
import getUnsafeRoomText from "../../base/util/getUnsafeRoomText.web";
import CalendarList from "../../calendar-sync/components/CalendarList.web";
import RecentList from "../../recent-list/components/RecentList.web";
import { _mapStateToProps, AbstractWelcomePage, } from "./AbstractWelcomePage";
import Tabs from "./Tabs";
import Header from "./Header";
import HeroSection from "./HeroSection";
import SupportProject from "./SupportProject";
import Advantages from "./Advantages";
import Footer from "./Footer";
import "../../../../css/_welcome.scss";
/**
 * The pattern used to validate room name.
 *
 * @type {string}
 */
export const ROOM_NAME_VALIDATE_PATTERN_STR = "^[^?&:\u0022\u0027%#]+$";
/**
 * The Web container rendering the welcome page.
 *
 * @augments AbstractWelcomePage
 */
class WelcomePage extends AbstractWelcomePage {
    /**
     * Initializes a new WelcomePage instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            generateRoomNames: interfaceConfig.GENERATE_ROOMNAMES_ON_WELCOME_PAGE,
        };
        /**
         * The HTML Element used as the container for additional content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentRef = null;
        this._roomInputRef = null;
        this._nameInputRef = null;
        /**
         * The HTML Element used as the container for additional toolbar content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentRef = null;
        this._additionalCardRef = null;
        /**
         * The template to use as the additional card displayed near the main one.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalCardTemplate = document.getElementById("welcome-page-additional-card-template");
        /**
         * The template to use as the main content for the welcome page. If
         * not found then only the welcome page head will display.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentTemplate = document.getElementById("welcome-page-additional-content-template");
        /**
         * The template to use as the additional content for the welcome page header toolbar.
         * If not found then only the settings icon will be displayed.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentTemplate = document.getElementById("settings-toolbar-additional-content-template");
        // Bind event handlers so they are only bound once per instance.
        this._onFormSubmit = this._onFormSubmit.bind(this);
        this._onRoomChange = this._onRoomChange.bind(this);
        this._onNameChange = this._onNameChange.bind(this);
        this._setAdditionalCardRef = this._setAdditionalCardRef.bind(this);
        this._setAdditionalContentRef =
            this._setAdditionalContentRef.bind(this);
        this._setRoomInputRef = this._setRoomInputRef.bind(this);
        this._setNameInputRef = this._setNameInputRef.bind(this);
        this._setAdditionalToolbarContentRef =
            this._setAdditionalToolbarContentRef.bind(this);
        // this._renderFooter = this._renderFooter.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();
        document.body.classList.add("welcome-page");
        document.title = "Tribe Meet";
        if (this.state.generateRoomNames) {
            this._updateRoomName();
        }
        if (this._shouldShowAdditionalContent()) {
            this._additionalContentRef?.appendChild(this._additionalContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalToolbarContent()) {
            this._additionalToolbarContentRef?.appendChild(this._additionalToolbarContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalCard()) {
            this._additionalCardRef?.appendChild(this._additionalCardTemplate?.content.cloneNode(true));
        }
    }
    /**
     * Removes the classname used for custom styling of the welcome page.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        super.componentWillUnmount();
        document.body.classList.remove("welcome-page");
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        return (React.createElement("div", { className: "wrapper" },
            React.createElement(Header, { onJoin: this._onJoin }),
            React.createElement("main", null,
                React.createElement(HeroSection, { onJoin: this._onJoin, onSubmit: this._onFormSubmit, roomInputRef: this._setRoomInputRef, nameInputRef: this._setNameInputRef, onChangeRoomInput: this._onRoomChange, onChangeNameInput: this._onNameChange, roomValue: this.state.room, nameValue: this.state.name }),
                React.createElement(SupportProject, null),
                React.createElement(Advantages, null)),
            React.createElement(Footer, null)));
    }
    /**
     * Renders the insecure room name warning.
     *
     * @inheritdoc
     */
    _doRenderInsecureRoomNameWarning() {
        return (React.createElement("div", { className: "insecure-room-name-warning" },
            React.createElement(Icon, { src: IconWarning }),
            React.createElement("span", null, getUnsafeRoomText(this.props.t, "welcome"))));
    }
    /**
     * Prevents submission of the form and delegates join logic.
     *
     * @param {Event} event - The HTML Event which details the form submission.
     * @private
     * @returns {void}
     */
    // _onFormSubmit(event) {
    //     event.preventDefault();
    //     // const randomRoomName = generateRandomString();
    //     // Генерируем случайное название комнаты
    //     // const randomRoomName = generateRandomString
    //     // Устанавливаем название комнаты
    //     this.setState({ room: randomRoomName }, () => {
    //         // Далее вызываем функцию, которая начинает звонок
    //         this._onJoin();
    //     });
    // }
    _onFormSubmit(event) {
        event.preventDefault();
        if (!this._roomInputRef || this._roomInputRef.reportValidity()) {
            this._onJoin();
        }
    }
    /**
     * Overrides the super to account for the differences in the argument types
     * provided by HTML and React Native text inputs.
     *
     * @inheritdoc
     * @override
     * @param {Event} event - The (HTML) Event which details the change such as
     * the EventTarget.
     * @protected
     */
    // @ts-ignore
    // eslint-disable-next-line require-jsdoc
    _onRoomChange(event) {
        super._onRoomChange(event.target.value);
    }
    /**
     * Renders the footer.
     *
     * @returns {ReactElement}
     */
    // _renderFooter() {
    //     const {
    //         t,
    //         _deeplinkingCfg: {
    //             ios = { downloadLink: undefined },
    //             android = {
    //                 fDroidUrl: undefined,
    //                 downloadLink: undefined,
    //             },
    //         },
    //     } = this.props;
    //     const { downloadLink: iosDownloadLink } = ios;
    //     const { fDroidUrl, downloadLink: androidDownloadLink } = android;
    //     return (
    //         <footer className="welcome-footer">
    //             <div className="welcome-footer-centered">
    //                 <div className="welcome-footer-padded">
    //                     <div className="welcome-footer-row-block welcome-footer--row-1">
    //                         <div className="welcome-footer-row-1-text">
    //                             {t("welcomepage.jitsiOnMobile")}
    //                         </div>
    //                         <a className="welcome-badge" href={iosDownloadLink}>
    //                             <img
    //                                 alt={t("welcomepage.mobileDownLoadLinkIos")}
    //                                 src="./images/app-store-badge.png"
    //                             />
    //                         </a>
    //                         <a
    //                             className="welcome-badge"
    //                             href={androidDownloadLink}
    //                         >
    //                             <img
    //                                 alt={t(
    //                                     "welcomepage.mobileDownLoadLinkAndroid"
    //                                 )}
    //                                 src="./images/google-play-badge.png"
    //                             />
    //                         </a>
    //                         <a className="welcome-badge" href={fDroidUrl}>
    //                             <img
    //                                 alt={t(
    //                                     "welcomepage.mobileDownLoadLinkFDroid"
    //                                 )}
    //                                 src="./images/f-droid-badge.png"
    //                             />
    //                         </a>
    //                     </div>
    //                 </div>
    //             </div>
    //         </footer>
    //     );
    // }
    /**
     * Renders tabs to show previous meetings and upcoming calendar events. The
     * tabs are purposefully hidden on mobile browsers.
     *
     * @returns {ReactElement|null}
     */
    _renderTabs() {
        if (isMobileBrowser()) {
            return null;
        }
        const { _calendarEnabled, _recentListEnabled, t } = this.props;
        const tabs = [];
        if (_calendarEnabled) {
            tabs.push({
                id: "calendar",
                label: t("welcomepage.upcomingMeetings"),
                content: React.createElement(CalendarList, null),
            });
        }
        if (_recentListEnabled) {
            tabs.push({
                id: "recent",
                label: t("welcomepage.recentMeetings"),
                content: React.createElement(RecentList, null),
            });
        }
        if (tabs.length === 0) {
            return null;
        }
        return (React.createElement(Tabs, { accessibilityLabel: t("welcomepage.meetingsAccessibilityLabel"), tabs: tabs }));
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * additional card shown near the tabs card.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalCardRef(el) {
        this._additionalCardRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * welcome page content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalContentRef(el) {
        this._additionalContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * toolbar additional content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the additional toolbar content.
     * @private
     * @returns {void}
     */
    _setAdditionalToolbarContentRef(el) {
        this._additionalToolbarContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLInputElement used to hold the
     * welcome page input room element.
     *
     * @param {HTMLInputElement} el - The HTMLElement for the input of the room name on the welcome page.
     * @private
     * @returns {void}
     */
    _setRoomInputRef(el) {
        this._roomInputRef = el;
    }
    _setNameInputRef(el) {
        this._nameInputRef = el;
    }
    /**
     * Returns whether or not an additional card should be displayed near the tabs.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalCard() {
        return (interfaceConfig.DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD &&
            this._additionalCardTemplate &&
            this._additionalCardTemplate.content &&
            this._additionalCardTemplate.innerHTML.trim());
    }
    /**
     * Returns whether or not additional content should be displayed below
     * the welcome page's header for entering a room name.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalContent() {
        return (interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT &&
            this._additionalContentTemplate &&
            this._additionalContentTemplate.content &&
            this._additionalContentTemplate.innerHTML.trim());
    }
    /**
     * Returns whether or not additional content should be displayed inside
     * the header toolbar.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalToolbarContent() {
        return (interfaceConfig.DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT &&
            this._additionalToolbarContentTemplate &&
            this._additionalToolbarContentTemplate.content &&
            this._additionalToolbarContentTemplate.innerHTML.trim());
    }
}
/**
 * Default values for {@code WelcomePage} component's properties.
 *
 * @static
 */
WelcomePage.defaultProps = {
    _room: "",
};
// const styles = {
//     headerStyle: {
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         height: "87px",
//         backgroundColor: "white",
//         borderRadius: "0px 0px 30px 30px",
//         padding: "0 20px",
//         boxSizing: "border-box" as "border-box",
//     },
//     logoStyle: {
//         marginTop: "0.9px",
//         marginLeft: "20px",
//     },
//     chatButtonStyle: {
//         backgroundColor: "#3313FC",
//         color: "#FFFFFF",
//         border: "none",
//         borderRadius: "25px",
//         padding: "12px 22px",
//         fontSize: "14px",
//         fontWeight: "700",
//         fontFamily: "Manrope, sans-serif",
//         cursor: "pointer",
//         outline: "none",
//         height: "43px",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         lineHeight: "19px",
//         marginRight: "20px",
//         zIndex: 99,
//     },
//     container: {
//         display: "flex",
//         flexDirection: "column" as "column",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "100vh",
//         backgroundColor: "white",
//         borderTopLeftRadius: "30px",
//         borderTopRightRadius: "30px",
//         marginTop: "20px",
//     },
//     header: {
//         color: "#3313FC",
//         fontSize: "70px",
//         fontWeight: "bold",
//         textAlign: "center" as "center",
//         marginBottom: "20px",
//     },
//     description: {
//         color: "#1D1D1D",
//         fontSize: "48px",
//         textAlign: "center" as "center",
//         marginBottom: "40px",
//     },
//     button: {
//         backgroundColor: "#3313FC",
//         color: "#fff",
//         borderRadius: "90px",
//         border: "none",
//         padding: "15px 115px 15px 115px",
//         fontSize: "18px",
//         cursor: "pointer",
//         marginBottom: "40px",
//     },
//     form: {
//         display: "flex",
//         flexDirection: "column" as "column",
//         maxWidth: "300px",
//     },
//     input: {
//         border: "1px solid #ccc",
//         borderRadius: "5px",
//         padding: "15px",
//         marginBottom: "20px",
//         fontSize: "16px",
//     },
//     joinButton: {
//         backgroundColor: "#3313FC",
//         color: "#fff",
//         borderRadius: "20px",
//         border: "none",
//         padding: "15px 30px",
//         fontSize: "18px",
//         cursor: "pointer",
//     },
//     leftContainer: {
//         display: "flex",
//         flexDirection: "column" as "column",
//         alignItems: "flex-start", // Элементы выравниваются по левому краю
//         justifyContent: "center", // Центрирование по вертикали
//         height: "100vh",
//         width: "50%", // Половина ширины родительского элемента
//         position: "fixed" as "fixed",
//         left: "5%", // Смещаем контейнер, чтобы он был по центру относительно своей половины экрана
//         top: "0",
//         padding: "0 20px", // Внутренний отступ с обеих сторон
//     },
//     rightContainer: {
//         display: "flex",
//         flexDirection: "column" as "column",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "100vh",
//         width: "50%",
//         position: "fixed" as "fixed",
//         right: "0",
//         top: "0",
//     },
//     formContainer: {
//         borderRadius: "20px",
//         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//         backgroundColor: "#F5F5F5",
//         // padding: '20px',
//         display: "flex",
//         flexDirection: "column" as "column",
//         width: "447px",
//         height: "270px",
//         // justifyContent: 'center',
//         alignItems: "center",
//     },
//     formInput: {
//         border: "1px solid #fff",
//         borderRadius: "90px",
//         padding: "15px",
//         marginBottom: "10px",
//         fontSize: "16px",
//         backgroundColor: "#FFFFFF",
//         boxShadow: "none",
//         width: "350px",
//         height: "50px",
//     },
//     formButton: {
//         backgroundColor: "#3313FC",
//         color: "#fff",
//         borderRadius: "90px",
//         border: "none",
//         padding: "15px 0",
//         fontSize: "18px",
//         cursor: "pointer",
//         marginTop: "20px",
//         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//         width: "350px",
//         height: "50px",
//     },
//     headerContainer: {
//         width: "100%",
//         height: "50px",
//         backgroundColor: "#FFFFFF",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         fontSize: "20px",
//         color: "#25252F",
//         marginBottom: "10px",
//         borderTopLeftRadius: "15.14px",
//         borderTopRightRadius: "15.14px",
//         fontWeight: "600",
//     },
//     stripesContainer: {
//         position: "absolute" as "absolute",
//         top: "0",
//         right: "0",
//         width: "50%", // половина ширины экрана
//         height: "100vh", // полная высота
//         display: "flex",
//         flexDirection: "column" as "column",
//         alignItems: "flex-end", // выравнивание полос к правому краю
//         justifyContent: "center", // центрирование по вертикали
//         zIndex: "-1", // чтобы полосы были под формой
//     },
//     stripe: {
//         width: "39.76px",
//         height: "484.48px", // высоту можно задать разную для каждой полосы
//         backgroundColor: "#E0E0E0",
//         borderRadius: "34.92px",
//         // можно добавить небольшой отступ между полосами, если это необходимо
//         marginBottom: "10px",
//         transform: "rotate(-180deg)",
//     },
//     main: {
//         backgroundColor: "#F5F5F5",
//     },
// };
export default translate(connect(_mapStateToProps)(WelcomePage));
